import React from 'react';
import './style.css';
import XtractIcon from '../Assets/XtractorBlack.svg';
import Logout from '../Assets/logout-svg-black.svg';
import { useNavigate } from 'react-router-dom';

function Header(props) {
  const navigate = useNavigate();
  return (
    <div className="container-fluid header px-5" style={{ borderBottom: props.border ? '1vh solid #F4F5F6':'none', zIndex: '10', position:'relative'}}>
        <div className='row p-0 m-0' style={{width: '90%'}}>
            <div className='col-6 header-col p-0 m-0'>
                {/* <img src={XtractIcon} width='80px' /> */}
                <p style={{color: '#0473ea', fontSize: '17px', marginBottom: '0'}}>Xtract<span style={{color: '#c9c9c9'}}>hub</span></p>
            </div>
        </div>
        {props.signOut && <p className="text-end mb-0" style={{ width: '10%',color: '#000', fontSize: '13px', fontWeight: '500', cursor: 'pointer' }} onClick={() => navigate('/')}><img src={Logout} className='me-2' width='25px' />Sign Out</p>}
    </div>
  )
}

export default Header;
